export default __webpack_public_path__ + "static/media/topup.097f519f.svg";